import SEO from "@/components/SEO";
import PageHeader from "@/components/PageHeader";
import IndustriesGrid from "@/sections/IndustriesGrid";
import Testimonials from "@/sections/Testimonials";
import CTABanner from "@/components/CTABanner";

export default function IndustriesPage() {
  return (
    <>
      <SEO
        title="Industries We Serve — Bengaluru"
        description="DiziTeQ serves healthcare, restaurants, hotels, clinics, dental, beauty, salons, spas, education, real estate, retail, construction, interior design, manufacturing and more."
        path="/industries"
      />
      <PageHeader
        eyebrow="Industries"
        title="Digital growth tailored to"
        highlight="your industry"
        subtitle="We understand what makes customers choose you — and we build strategies around it. Explore the industries we specialise in."
      />
      <IndustriesGrid showHeader={false} />
      <Testimonials />
      <div className="py-10"><CTABanner /></div>
    </>
  );
}
